import {Component, Inject, Optional} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-edit-lesson-warning',
    templateUrl: './edit-lesson-warning.component.html',
    standalone: false
})
export class EditLessonWarningComponent {

    constructor(public selfDialogRef: MatDialogRef<EditLessonWarningComponent>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: { count: number }) {
    }

    accept(): void {
        this.selfDialogRef.close(true);
    }

    cancel(): void {
        this.selfDialogRef.close(false);
    }
}